import type {
  MessageRouter,
  ReceiverInput,
  ReceiverOutput,
} from "@pdfking/functionpool"
import type { APIRequest } from "../../types/api/APIRequest"
import type { APIResponse } from "../../types/api/APIResponse"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import type { TaskOptions } from "../../types/tasks/TaskOptions"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"
import {
  Channel,
  First,
  FullMethodDispatcher,
  ProcessIterable,
} from "@pdfking/tfunc"
import { TaskName } from "../../types/tasks/TaskName"
import { CreateEngineVirtual } from "../CreateEngineVirtual"
import * as Tasks from "./Tasks"

const implementations = FullMethodDispatcher<
  [TaskOptions, TrackingCallback, PdfEngine, ReceiverInput<APIRequest>],
  ReceiverOutput<APIResponse>
>(Tasks)

export const APIReceiver = async function* (
  input: ReceiverInput<APIRequest>,
  forward: MessageRouter<APIRequest, APIResponse> // for the way we cache we should never use forward
): ReceiverOutput<APIResponse> {
  const task = (await First(input)) as TaskOptions
  const { push, stop, stream } = Channel<APIResponse>()

  const emit: TrackingCallback = async rest =>
    push({
      enum: TaskName.TRACKING,
      ...rest,
    })

  const engine = CreateEngineVirtual(task.options, forward)

  void ProcessIterable(implementations(task, emit, engine, input), push, stop)

  yield* stream
}
